import { __rest } from "tslib";
import React, { Fragment, memo } from 'react';
import { Tabs } from '@gravity-ui/uikit';
import { block, getBlockKey } from '../../../utils';
import { BlockForm } from '../../components/BlockForm/BlockForm';
import { CodeEditor } from '../../components/CodeEditor/CodeEditor';
import { PagePropsForm } from '../../components/PagePropsForm/PagePropsForm';
import useFormSpec from '../../hooks/useFormSpec';
import { FormTab } from '../../types';
import { useCode } from './hooks';
import './Form.css';
const b = block('editor-form');
const tabsItems = Object.values(FormTab).map((tab) => ({
    id: tab,
    title: tab,
}));
export const Form = memo(({ content, onChange, activeBlockIndex, onSelect, schema, codeValidator, activeTab, onActiveTabUpdate, codeFullscreeModeOn, onCodeFullscreeModeOnUpdate, }) => {
    const _a = content || {}, { blocks } = _a, page = __rest(_a, ["blocks"]);
    const code = useCode({ activeTab, content, codeFullscreeModeOn });
    const spec = useFormSpec(schema);
    const { blocks: blocksSpec, page: pageSpec } = spec || {};
    let form;
    switch (activeTab) {
        case FormTab.Page: {
            form = (React.createElement(PagePropsForm, { spec: pageSpec, data: page, onChange: (data) => {
                    return onChange(Object.assign(Object.assign({}, content), data));
                } }));
            break;
        }
        case FormTab.Blocks: {
            form = (React.createElement(Fragment, null, blocks.map((blockData, index) => blocksSpec[blockData.type] ? (React.createElement("div", { className: b('block-form'), key: getBlockKey(blockData, index) },
                React.createElement(BlockForm, { spec: blocksSpec[blockData.type], data: blockData, active: activeBlockIndex === index, onChange: (data) => {
                        onChange(Object.assign(Object.assign({}, content), { blocks: [
                                ...blocks.slice(0, index),
                                data,
                                ...blocks.slice(index + 1),
                            ] }));
                    }, onSelect: () => onSelect(index) }))) : null)));
            break;
        }
        case FormTab.Code: {
            form = (React.createElement(CodeEditor, { code: code, onChange: onChange, validator: codeValidator, fullscreenModeOn: codeFullscreeModeOn, onFullscreenModeOnUpdate: onCodeFullscreeModeOnUpdate }));
            break;
        }
    }
    return (React.createElement("div", { className: b({ 'code-editor-active': activeTab === FormTab.Code }) },
        React.createElement(Tabs, { activeTab: activeTab, className: b('tabs'), items: tabsItems, onSelectTab: onActiveTabUpdate }),
        form));
});
Form.displayName = 'Form';
